import React, { useState } from 'react';
import Test3DView from './Test3DView';
import IsometricDatacenterView from './IsometricDatacenterView';
import { Box, Layers } from 'lucide-react';
import { LocationData } from '../types';

interface Test3DViewToggleProps {
  locations: Record<string, LocationData>;
  currentLocation: string;
}

type ViewMode = '3d' | 'iso' | null;

const Test3DViewToggle: React.FC<Test3DViewToggleProps> = ({ locations, currentLocation }) => {
  const [view, setView] = useState<ViewMode>(null);
  const locationData = locations[currentLocation] ?? null;

  if (view === '3d') {
    return (
      <div className="fixed inset-0 z-50 bg-black bg-opacity-90 flex flex-col">
        <Test3DView locations={locations} currentLocation={currentLocation} />
        <button
          className="absolute top-4 left-4 bg-red-600 hover:bg-red-700 text-white py-2 px-4 rounded-md flex items-center gap-2"
          onClick={() => setView(null)}
        >
          ✕ Close
        </button>
      </div>
    );
  }

  if (view === 'iso') {
    return (
      <div className="fixed inset-0 z-50 bg-gray-950 flex flex-col">
        <div className="flex items-center gap-4 px-4 py-2 bg-gray-900 border-b border-gray-700">
          <span className="text-white font-semibold text-sm">Isometric View — Test</span>
          <span className="text-gray-400 text-xs">Concept preview based on image 2</span>
          <button
            className="ml-auto bg-red-600 hover:bg-red-700 text-white py-1 px-3 rounded text-sm"
            onClick={() => setView(null)}
          >
            ✕ Close
          </button>
        </div>
        <div className="flex-1 overflow-hidden">
          <IsometricDatacenterView locationData={locationData} />
        </div>
      </div>
    );
  }

  return (
    <div className="fixed bottom-4 right-4 z-40 flex flex-col gap-2 items-end">
      <button
        className="bg-indigo-600 hover:bg-indigo-700 text-white py-2 px-4 rounded-full flex items-center gap-2 shadow-lg text-sm"
        onClick={() => setView('iso')}
      >
        <Layers size={16} />
        Isometric View
      </button>
      <button
        className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 rounded-full flex items-center gap-2 shadow-lg text-sm"
        onClick={() => setView('3d')}
      >
        <Box size={16} />
        3D View
      </button>
    </div>
  );
};

export default Test3DViewToggle;
